/**
 * Created by Daniela on 30/01/2017.
 */
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { BombaNavigationService } from "../shared/bomba-navigation.service";
import { BombaApiService } from "../shared/bomba-api.service";
import { UtilService } from "../../../shared/services/util.service";
import { Bomba } from "../shared/bomba.model";
import { bombasAuditoriaModuleName } from "../shared/data.service";
import { AbastecimentoBemNavigationService } from "../../abastecimento-bens/shared/abastecimento-bem-navigation.service";
import { abastecimentosModuleName } from "../../shared/data.service";

@Component({
    template: require('./bomba-auditoria.component.html'),
    styles: [require('./bomba-auditoria.component.css')]
})
export class BombaAuditoriaComponent implements OnInit {
    bombaObject: any = new Bomba();
    audits: any = null;
    formObject: any = {};
    loading: boolean = false;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    bombasAuditoriaModule: any = bombasAuditoriaModuleName;
    module: any = abastecimentosModuleName;

    formT: FormGroup;
    dataFim = new FormControl('', Validators.required);
    dataInicio = new FormControl('', Validators.required);

    private bombaId: number;

    constructor(
        private _bombaNavigationService: BombaNavigationService,
        private _bombasApiService: BombaApiService,
        private _utilService: UtilService,
        private _abastecimentoNavigationService: AbastecimentoBemNavigationService,
        private _route: ActivatedRoute,
        private _cdRef:ChangeDetectorRef,
        private _fb: FormBuilder
    ) {
        this.formT = _fb.group({
            dataFim: this.dataFim,
            dataInicio: this.dataInicio
        });
    }

    ngOnInit() {
        this.bombaId = +this._route.snapshot.params['id'];
        this._utilService.disabledFutureDates('dataInicio');
        this._utilService.disabledFutureDates('dataFim');

        this.formObject.dataFim = this._utilService.convertDateToString(new Date());
        this.getBomba();
    }

    ngAfterViewChecked() {
        this._cdRef.detectChanges();
    }

    clickAuditoriaList() {
        this._bombaNavigationService.goToAuditoriaList();
    }

    clickGoToDetail() {
        this._bombaNavigationService.goToAuditoriaDetail(this.bombaId);
    }

    clickAjustar() {
        this._abastecimentoNavigationService.goToNew();
    }

    onSubmit(evt: any) {
        this.submitted = true;

        let startDate: any = document.getElementById('dataInicio');
        if (!startDate.value) {
            return false;
        }

        this.formObject.dataInicio = startDate.value;

        let endDate: any = document.getElementById('dataFim');
        if (!endDate.value) {
            return false;
        }

        this.formObject.dataFim = endDate.value;

        let object: any = this._utilService.cloneObject(this.formObject);
        object.bombaId = this.bombaId;
        object.dataInicio = this._utilService.convertStringToDate(startDate.value);
        object.dataFim = this._utilService.convertStringToDate(endDate.value);

        this.loading = true;
        this.audits = null;
        this.onAudit(object);
    }

    private onAudit(object: any) {
        this._bombasApiService.onPostAuditar(object, this.onDoneAudit);
    }

    private onDoneAudit = (function (Response: any) {
        if (!Response.error)  {
            Response.inconformidade = Response.totalContabilizado - Response.totalEsperado;
            this.audits = Response;

            //totalContabilizado: soma dos abastecimentos
            //totalEsperado: soma dos hidrometros
        } else {
            this._utilService.swalMessageWarningCustom(Response.error);
        }
        this.loading = false;
    }.bind(this));

    private getBomba() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.bombaObject = Response;
            }
        }.bind(this));

        this._bombasApiService.onGetById(this.bombaId, onDone);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/bombas/bomba-auditoria/bomba-auditoria.component.ts
 **/